const getFileType = (blob: Blob) => {
    const [type, extension] = blob.type.split('/');

    return { type, extension };
};

export const downloadFile = async (blob: Blob, filename: string = 'file') => {
    try {
        const objectUrl = URL.createObjectURL(blob);

        const { extension } = getFileType(blob);

        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = `${filename}.${extension}`;
        a.click();

        URL.revokeObjectURL(objectUrl);
    } catch (error) {
        const objectUrl = URL.createObjectURL(blob);
        window.open(objectUrl, '_blank');
        URL.revokeObjectURL(objectUrl);
    }
};
